// extracted by mini-css-extract-plugin
export default {"titleContainer":"tickets-search-page_titleContainer__340W+","overdueTicketBtn":"tickets-search-page_overdueTicketBtn__RHFqv"};